<template>
  <div id="app">
    <router-view></router-view>
    <div class="status-icon">
      <font-awesome-icon icon="triangle-exclamation" v-if="!store.state.pwa.online"/>
      <font-awesome-icon icon="spinner" spin v-else-if="backgroundDataLoading"/>
    </div>
    <portal-target name="root"></portal-target>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'app',

  setup() {
    // eslint-disable-next-line no-undef
    const store = useStore()
    const backgroundDataLoading = computed(() => store.getters['backgroundDataLoading'])

    return {
      store,
      backgroundDataLoading,
    }
  }
}
</script>

<style lang="scss">
.status-icon {
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 999;
  pointer-events: none;
}
</style>
